<template>
  <div>
    <v-dialog ref="dialog" persistent v-model="dialog" max-width="800">
      <v-card>
        <v-card-title>Alterar aula: {{ item.name }}</v-card-title>
        <v-card-text>
          <template>
            <v-row class="d-flex flex-column">
              <v-checkbox
                label="Cancelar aula"
                v-model="selected"
                value="cancel"
              />
              <v-checkbox
                label="Escolher outro assunto"
                v-model="selected"
                value="next"
              />
              <v-checkbox
                label="Escolher outro dia"
                v-model="selected"
                value="other"
              />
            </v-row>
            <v-row v-if="canceling">
              <v-textarea
                solo
                name="input-7-1"
                label="Informe o motivo:"
                hint="Qual o motivo da aula ser adiada ?"
                v-model="motivo"
              ></v-textarea>
            </v-row>
            <v-row v-else-if="updateLeasson">
              <v-row dense>
                <v-col class="d-flex align-center justify-center" cols="12">
                  <v-select
                    v-model="searchLevel"
                    label="Escolha o nível"
                    :items="englishLevels"
                    :item-text="`text`"
                    :item-value="`text`"
                  />
                </v-col>
                <v-col
                  class="d-flex align-center justify-center flex-column"
                  cols="12"
                >
                  <v-progress-circular
                    v-if="searchLevelLoading"
                    indeterminate
                  ></v-progress-circular>
                  <span v-if="searchLevelLoading">Consultando assuntos</span>
                </v-col>
                <v-col class="d-flex align-center justify-center" cols="12">
                  <v-select
                    label="Escolha o assunto"
                    :items="newClassSelectContent"
                    :item-text="`title`"
                    :item-value="`id`"
                    v-if="!searchLevelLoading && newClassSelectContent"
                    v-model="newContent"
                  />
                  <span v-else-if="noContentMessage"
                    >Nenhum conteúdo encontrado</span
                  >
                </v-col>
              </v-row>
            </v-row>
            <v-row v-if="selected === 'other'">
              <v-col
                class="d-flex align-center justify-center flex-column"
                v-if="loadingMatch"
              >
                <v-progress-circular indeterminate></v-progress-circular>
                Consultando horários disponíveis
              </v-col>
              <v-col
                class="d-flex align-center justify-center flex-column"
                v-else
              >
                <span v-if="matched.length === 0">
                  Nenhum horário disponível</span
                >
                <div v-else style="height: 100%; width: 100%">
                  <date-picker ref="picker" :horarios="matched" />
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="close">
            <v-icon>mdi-clock-outline</v-icon>cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            circle
            plain
            @click="late"
            v-bind:disabled="selected == null"
          >
            <v-icon>mdi-check-outline</v-icon>Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import partnerApi from "@/shared/pitchPartnerApi";
import { format } from "date-fns";
export default {
  name: "class-adiar-dialog",
  props: {
    item: {
      type: Object,
    },
  },
  data: () => {
    return {
      searchLevel: null,
      searchLevelLoading: false,
      loadingMatch: true,
      updateLeasson: false,
      newClassSelectContent: null,
      noContentMessage: false,
      matched: [],
      selected: null,
      dialog: false,
      postpone: false,
      canceling: false,
      motivo: "",
      newContent: null,
      englishLevels: [
        {
          text: "Beginner 1",
          value: 0,
        },
        {
          text: "Beginner 2",
          value: 1,
        },
        {
          text: "Essential 1",
          value: 2,
        },
        {
          text: "Essential 2",
          value: 3,
        },
        {
          text: "Pre Intermediate 1",
          value: 4,
        },
        {
          text: "Pre Intermediate 2",
          value: 5,
        },
        {
          text: "Intermediate 1",
          value: 6,
        },
        {
          text: "Intermediate 2",
          value: 7,
        },
        {
          text: "Upper 1",
          value: 8,
        },
        {
          text: "Upper 2",
          value: 9,
        },
        {
          text: "Advanced 1",
          value: 10,
        },
        {
          text: "Advanced 2",
          value: 11,
        },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      this.$emit("confirm", this.item);
    },
    formatDate(date) {
      return format(date, "dd/MM/yyyy HH:mm");
    },
    late() {
      const item = Object.assign({}, this.item);
      if (this.selected === "cancel") {
        item.motivo = this.motivo;
        item.newDate = this.date;
      } else if (this.selected === "next") {
        item.data = this.newContent;
      } else if (this.selected === "other") {
        item.data = this.$refs.picker.getData();
      }

      this.$emit("confirm", {
        item,
        action: this.selected,
        motivo: this.motivo,
      });
    },
  },
  watch: {
    selected: function (value) {
      if (value === "cancel") {
        this.canceling = true;
        this.updateLeasson = false;
      } else if (value === "next") {
        this.updateLeasson = true;
        this.canceling = false;
      } else if (value === "other") {
        this.updateLeasson = false;
        this.canceling = false;
        partnerApi.rearrange(this.item.id, this.item.classId).then((res) => {
          this.loadingMatch = false;
          this.matched = res.data;
        });
      } else this.canceling = false;
    },
    searchLevel: function (level) {
      this.searchLevelLoading = true;
      this.noContentMessage = false;
      partnerApi
        .getClassContentByLevel(level.replace(" ", "").toUpperCase())
        .then((res) => {
          this.newClassSelectContent = res.data.content;
          if (!this.newClassSelectContent) this.noContentMessage = true;
          this.searchLevelLoading = false;
        })
        .catch(() => {
          this.searchLevelLoading = false;
        });
    },
  },
};
</script>
<style lang="css"></style>
